import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { dossierAdapter, initialState } from "./state";

import { caseManagerApi } from "services/streamingApi/caseManager.api";
import { DossierInformationChanged } from "features/cases/types/DossierInformationChanged";
import { DossierRemoved } from "features/cases/types/DossierRemoved";
import { PersistentRecordingTaskStatistics } from "types/PersistentRecordingTaskStatistics";
import { PersistedRecordingDownloadStatus } from "types/PersistedRecordingDownloadStatus";

// slice
export const caseManagementSlice = createSlice({
    name: "caseManagement",
    initialState,
    reducers: {
        updateDossierDownloadStatusStatistics: (
            state,
            action: PayloadAction<{
                dossierDownloadStatusStatistics: PersistentRecordingTaskStatistics<PersistedRecordingDownloadStatus>;
            }>,
        ) => {
            if (action.payload.dossierDownloadStatusStatistics) {
                dossierAdapter.updateOne(state.dossiers, {
                    id: action.payload.dossierDownloadStatusStatistics
                        .dossierId,
                    changes: {
                        dossierDownloadStatusStatistics:
                            action.payload.dossierDownloadStatusStatistics,
                    },
                });
            }
        },
        updateDossierInformation: (
            state,
            action: PayloadAction<{
                dossierInformationChanged: DossierInformationChanged;
            }>,
        ) => {
            if (action.payload.dossierInformationChanged) {
                dossierAdapter.updateOne(state.dossiers, {
                    id: action.payload.dossierInformationChanged.dossierId,
                    changes: {
                        ...action.payload.dossierInformationChanged,
                    },
                });
            }
        },
        removeDossier: (
            state,
            action: PayloadAction<{
                dossierRemoved: DossierRemoved;
            }>,
        ) => {
            if (action.payload.dossierRemoved) {
                dossierAdapter.removeOne(
                    state.dossiers,
                    action.payload.dossierRemoved.dossierId,
                );
            }
        },
    },
    extraReducers(builder) {
        const getDossiers = caseManagerApi.endpoints.getDossiers;

        builder.addMatcher(getDossiers.matchPending, (state) => {
            dossierAdapter.removeAll(state.dossiers);
            state.totalDossiers = undefined;
            state.isLoadingDossiers = true;
            state.errorLoadingDossiers = undefined;
        });
        builder.addMatcher(getDossiers.matchFulfilled, (state, action) => {
            dossierAdapter.setAll(state.dossiers, action.payload.data);
            state.totalDossiers = action.payload.totalRecords;
            state.isLoadingDossiers = false;
        });
        builder.addMatcher(getDossiers.matchRejected, (state, action) => {
            state.isLoadingDossiers = false;
            state.errorLoadingDossiers = action.error.message;
        });
    },
});

// exports
export const caseManagementThunks = {};

export const caseManagementActions = caseManagementSlice.actions;

export default caseManagementSlice.reducer;
